import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function UpdateProjectModal({ project, onClose, onUpdateProject, clients }) {
    const [formData, setFormData] = useState({
        id: '',
        nome: '',
        valor: '',
        data_inicio: '',
        data_termino: '',
        status: '',
        cliente_nome: '',
        cliente_id: '',  // Guardando o id do cliente para envio ao backend
    });

    useEffect(() => {
        if (project) {
            // Preenche os campos do formulário com os dados do projeto selecionado
            const cliente = clients.find(client => client.id === project.id_cliente);
            setFormData({
                id: project.id,
                nome: project.nome,
                valor: project.valor,
                data_inicio: project.data_inicio,
                data_termino: project.data_termino,
                status: project.status,
                cliente_nome: cliente ? cliente.nome : '',
                cliente_id: project.id_cliente, // Guardando o id do cliente
            });
        }
    }, [project, clients]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Envia apenas os campos que o backend realmente espera
        onUpdateProject({
            id: formData.id,
            id_cliente: formData.cliente_id,
            valor: formData.valor,
            data_inicio: formData.data_inicio,
            data_termino: formData.data_termino,
            status: formData.status,
        });
    };


    return (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50">
            <div className="glass-panel p-6 w-full max-w-2xl text-white w-96">
                <h2 className="text-xl font-bold text-white mb-6 tracking-wide">Atualizar Projeto</h2>
                <form onSubmit={handleSubmit}>
                    {/* Cliente - Select */}
                    <div className="mt-4">
                        <label className="block text-sm font-medium text-gray-200">Cliente</label>
                        <select
                            name="cliente_id"
                            value={formData.cliente_id}
                            onChange={handleChange}
                            className="glass-input w-full"
                        >
                            <option value="">Selecione um cliente</option>
                            {clients.map((client) => (
                                <option key={client.id} value={client.id}>
                                    {client.nome}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Valor */}
                    <div className="mt-4">
                        <label className="block text-sm font-medium text-gray-200">Valor</label>
                        <input
                            type="number"
                            name="valor"
                            value={formData.valor}
                            onChange={handleChange}
                            className="glass-input w-full"
                        />
                    </div>

                    {/* Data de Início */}
                    <div className="mt-4">
                        <label className="block text-sm font-medium text-gray-200">Data de Início</label>
                        <input
                            type="date"
                            name="data_inicio"
                            value={formData.data_inicio}
                            onChange={handleChange}
                            className="glass-input w-full"
                        />
                    </div>

                    {/* Data de Término */}
                    <div className="mt-4">
                        <label className="block text-sm font-medium text-gray-200">Data de Término</label>
                        <input
                            type="date"
                            name="data_termino"
                            value={formData.data_termino}
                            onChange={handleChange}
                            className="glass-input w-full"
                        />
                    </div>

                    {/* Status */}
                    <div className="mt-4">
                        <label className="block text-sm font-medium text-gray-200">Status</label>
                        <select
                            name="status"
                            value={formData.status}
                            onChange={handleChange}
                            className="glass-input w-full"
                        >
                            <option value="Novo">Novo</option>
                            <option value="Em Andamento">Em Andamento</option>
                            <option value="Concluído">Concluído</option>
                            <option value="Aguardando">Aguardando</option>
                        </select>
                    </div>

                    <div className="mt-6 flex justify-between">
                        <button
                            type="button"
                            onClick={onClose}
                            className="bg-gray-400 text-white py-2 px-4 rounded-md hover:bg-gray-500"
                        >
                            Fechar
                        </button>
                        <button
                            type="submit"
                            className="bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600"
                        >
                            Atualizar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
